export default __webpack_public_path__ + "static/media/3.40119014.png";